module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/diseases-b06f3fa973eb773ce9e895ec75f061d2.svg";